import Layout from '@/components/layout/Layout.vue'
import CreateForm from '@/views/sys/corporation/create/Create.vue'
import { getCorporations, deleteCorporations } from '@/api/corporation'

const columns = [
    { title: 'ID', dataIndex: 'id' },
    { title: '主体名称', dataIndex: 'name' },
    { title: '操作', dataIndex: '', scopedSlots: { customRender: 'action' } }
]

export default {
    name: 'corporations',
    components: {
        Layout,
        CreateForm
    },
    data () {
        return {
            data: [],
            pagination: {
                defaultPageSize: 20,
                showSizeChanger: true,
                onShowSizeChange: this.pageSizeChange,
                pageSizeOptions: ['10', '20', '30', '40', '60', '80', '100'],
                showTotal: (total) => {
                    return ' 共 ' + total + ' 条'
                },
            },
            loading: false,
            selectedRowKeys: [],
            columns,
            model: {},
            showForm: false,
            queryParam: {}
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        create(record) {
            this.model = record.id ? Object.assign({}, record) : { enabled: true }
            this.showForm = true
        },
        destroy(record) {
            const del = ids => {
                deleteCorporations(ids).then(res => {
                    this.$message.destroy()
                    if (res && res.code === 0) {
                        this.$message.success('删除成功')
                        this.refresh()
                    }
                })
            }
            if (!record) {
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div style="color:red;">确定要删除选中的 {this.selectedRowKeys.length} 条数据吗?</div>,
                    onOk: () => {
                        del(this.selectedRowKeys)
                    }
                })
            }
            del([record.id])
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys
        },
        handleTableChange(pagination) {
            const pager = { ...this.pagination }
            pager.current = pagination.current
            this.pagination = pager
            this.getData()
        },
        getData() {
            this.loading = true
            const pagination = { ...this.pagination }
            const json = Object.assign({}, this.queryParam, {
                page: pagination.current,
                page_size: pagination.defaultPageSize
            })

            getCorporations(json).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list
                this.pagination = pagination
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.pagination.current = 1
            this.getData()
        },
        resetSearch() {
            this.queryParam = {}
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('CorporationController', route)
        },
        pageSizeChange(val, pageSize) {
            this.loading = true
            this.pagination.defaultPageSize = pageSize
            this.pagination.current = 1
        },
    }
}
